export class Range{
  constructor (lid, rid) {
    this.el = document.getElementById(lid);
    this.rEl = document.getElementById(rid);
    this.X = 0;
    this.moveX = 0;
    this.isDown = false;
    this.elL = 0;
    this.maxMove = this.el.parentElement.getBoundingClientRect().width - 34;
    this.parentEl = this.el.parentElement;
    this.rightl = 34;
    this.minX = 0;
    this.rId = rid;
  }
  init (cb, up) {
    this.onMouseDown(cb);
    this.onMouseUp(up);
  }
  onMouseDown (cb) {
    this.el.addEventListener('mousedown', (e) => {
      this.X = e.clientX;
      this.isDown = true;
      this.elL = this.el.offsetLeft;
      this.rightl = 0;
      this.onMouseMove(cb);
    })
  }
  onMouseMove (cb) {
    window.addEventListener('mousemove', (e) => {
      this.rEl.removeEventListener('mousedown',() => {});
      if(!this.isDown){
        return;
      }
      let rof = this.rEl.offsetLeft;
      let moX = e.clientX - (this.X - this.elL);

      if(this.rId !== e.target.id && e.target.id !== ''){
        if(rof > moX){
          this.maxMove = rof - 34;
        }
        if(rof < moX){
          this.minX = rof + 34;
        }
      }
      this.moveX = e.clientX - (this.X - this.elL);

      if(this.moveX < this.minX){
        this.moveX = this.minX;
      }
      if(this.moveX > this.maxMove){
        this.moveX = this.maxMove;
      }
      typeof cb == 'function' && cb(this.moveX);
    })
  }
  onMouseUp (up) {
    window.addEventListener('mouseup', (e) => {
      if(this.isDown){
        typeof up === 'function' && up(this.moveX);
      }
      this.isDown = false;
    });
  }
}




// WEBPACK FOOTER //
// ./src/components/range.js